<script setup>
import { Link } from '@inertiajs/vue3'
import { Button } from '@/Components/ui/button'
import { ShieldCheck } from 'lucide-vue-next'
import { tutors } from '@/routes/index'

/**
 * The closing line states the selection process, not an acceptance rate.
 *
 * The concept closed with "we accept less than 10% of applicants". Nobody has
 * counted that, and in the UK it is an advertising claim we would have to
 * substantiate on request. What we can stand behind is what every tutor goes
 * through, which is the same reassurance without the exposure.
 */
</script>

<template>
  <section class="pb-16 md:pb-24">
    <div class="container-page">
      <div
        v-reveal
        class="flex flex-col gap-5 rounded-lg border border-line-brand bg-surface-brand p-6 sm:flex-row sm:items-center md:p-8"
      >
        <span class="grid size-14 shrink-0 place-items-center rounded-full bg-brand-soft text-brand">
          <ShieldCheck class="size-7" />
        </span>

        <div class="flex-1">
          <h2 class="text-xl md:text-2xl">Every tutor is checked before they teach</h2>
          <p class="mt-1.5 text-[15px] text-muted">
            Degree verified, own A-level grades verified, interviewed and DBS checked. No exceptions.
          </p>
        </div>

        <Link :href="tutors()" class="sm:shrink-0">
          <Button class="w-full sm:w-auto">Find your tutor</Button>
        </Link>
      </div>
    </div>
  </section>
</template>
